(function ($, Drupal, drupalSettings, GMaps, google, once) {
  'use strict';

  drupalSettings.itineraryMap = {
    maps: [],
    selectListingItem: function (id) {

      var stops = $('.itinerary-stop');

      stops.filter('[data-entity-id="' + id + '"]').addClass('selected');
      stops.not('[data-entity-id="' + id + '"]').removeClass('selected');

      var container = $('html, body');
      var el = stops.filter('.selected').find('h2');
      var el_offset = -400;
      var el_top = el.offset().top + $('#content').offset().top + el_offset;

      container.animate({
        scrollTop: el_top
      }, 1000);

      // this.setMarkers(false);
    },
    setMarkers: function (target, rebound) {
      var parent = this;

      var itin = $(target).closest('.paragraph--type-article-itinerary');
      var id = itin.data('entityId');

      drupalSettings.itineraryMap.maps[id].removeMarkers();

      var map_markers = [];

      var stops = $('.itinerary-stop', itin);
      stops.each(function () {
        var marker = {
          id: $(this).data('entityId'),
          latitude: $(this).attr('itinerary-lat'),
          longitude: $(this).attr('itinerary-lon'),
          selected: $(this).hasClass('selected')
        };
        if (marker.latitude && marker.longitude) {
          map_markers.push(marker);
        }
      });

      if (map_markers.length) {
        var bounds = [];
        // Load map markers.
        map_markers.forEach(function (arrayItem) {
          var latlng = new google.maps.LatLng(arrayItem.latitude, arrayItem.longitude);
          bounds.push(latlng);
          var icon = arrayItem.selected ? drupalSettings.tnv_google_maps.settings.mytrip_pin : drupalSettings.tnv_google_maps.settings.default_pin;
          drupalSettings.itineraryMap.maps[id].addMarker({
            lat: arrayItem.latitude,
            lng: arrayItem.longitude,
            icon: icon,
            zIndex: arrayItem.selected ? 100 : 1,
            click: function (e) {
              parent.selectListingItem(arrayItem.id);
              var asset = $('.paragraph--type-article-itinerary').find("[data-entity-id='" + arrayItem.id + "'] .itinerary-content h2").text();

              // *disable-eslint*

              /* eslint-disable */
              dataLayer.push({
                eventCategory: 'article itinerary',
                eventAction: 'map click',
                eventLabel: asset,
                eventvalue: '',
                event: 'eventClick'
              });

              // *enable-eslint*

              /* eslint-enable */
            }
          });
        });
        if (rebound === true) {
          drupalSettings.itineraryMap.maps[id].fitLatLngBounds(bounds);
        }
      }
    },
    loadMap: function (target) {
      if (target.length === 0) {
        return;
      }
      else {
        target = target[0];
      }

      var itin = $(target).closest('.paragraph--type-article-itinerary');
      var id = itin.data('entityId');

      drupalSettings.itineraryMap.maps[id] = new GMaps({
        div: target,
        lat: 35.5175,
        lng: -86.5804,
        zoom: 7,
        disableDefaultUI: false,
        scaleControl: true,
        scrollwheel: false
      });

      drupalSettings.itineraryMap.maps[id].addStyle({
        styledMapName: 'Styled Map',
        styles: JSON.parse(drupalSettings.tnv_google_maps.settings.style),
        mapTypeId: 'map_style'
      });
      drupalSettings.itineraryMap.maps[id].setStyle('map_style');

      this.setMarkers(target, true);

    },
    createIndicator: function (target) {
      $('<div class="active-marker"></div>').prependTo(target);
    },
    createToggle: function (target) {
      var itin = $(target).closest('.paragraph--type-article-itinerary');
      var sticky = $('.sticky-element-parent', itin);
      var toggle = $('<div class="map-toggle sticky-element js-map-toggle">Map View</div>').prependTo(sticky);

      toggle.on('click', function (e) {
        $('body').toggleClass('itinerary-map-active');
        drupalSettings.itineraryMap.setMarkers(target, true);
      });
    },
    createMap: function (target) {
      var itin = $(target).closest('.paragraph--type-article-itinerary');
      var sticky = $('.sticky-element-parent', itin);
      var map_target = $('<div class="itinerary-map sticky-element">').prependTo(sticky);
      this.loadMap(map_target);
    },
    scrollStop: function (target) {
      var parent = $(target.element).closest('.paragraph--type-article-itinerary');
      var stop = $(target.element).closest('.itinerary-stop');
      var headingTop = $(target.element).offset().top - parent.offset().top;

      $('.active-marker', parent).css('transform', 'translateY(' + headingTop + 'px)');
      $('.itinerary-stop').removeClass('selected');
      stop.addClass('selected');
      drupalSettings.itineraryMap.setMarkers(parent, true);
    },
    watchStops: function (target) {
      // Set waypoints.
      var stops = $('.itinerary-stop', target);
      $(once('itinerary-waypoint', stops)).each(function () {
        $('h2', this).waypoint({
          handler: function (direction) { if (direction === 'down') { drupalSettings.itineraryMap.scrollStop(this); }},
          offset: '90%'
        });
        $('h2', this).waypoint({
          handler: function (direction) { if (direction === 'up') { drupalSettings.itineraryMap.scrollStop(this); }},
          offset: '10%'
        });
      });
    }
  };

  Drupal.behaviors.itineraryMap = {
    attach: function () {
      $(once('itinerary-map-load', '.paragraph--type-article-itinerary')).each(function () {
        drupalSettings.itineraryMap.createIndicator(this);
        drupalSettings.itineraryMap.createToggle(this);
        drupalSettings.itineraryMap.createMap(this);
        drupalSettings.itineraryMap.watchStops(this);
      });

      return;
    }
  };

})(jQuery, Drupal, drupalSettings, GMaps, google, once); // eslint-disable-line no-undef
